// Importing constant
import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

/**
 * Constants defining URLs related to payments.
 */
export const PAYMENTS = {
  ROOT: `${PRIVATE_ROOT}/payments`,
  AUTO_PAYMENTS: `${PRIVATE_ROOT}/payments/auto-payments`,
  ONE_CLICK_AUTO_PAYMENT: `${PRIVATE_ROOT}/payments/one-click-autopayment`,
  ADD_AUTO_PAYMENT: {
    ROOT: `${PRIVATE_ROOT}/payments/add-auto-payment`,
    BI_MONTHLY: `${PRIVATE_ROOT}/payments/add-auto-payment/bi-monthly`,
    ROOMMATE_SPLIT: `${PRIVATE_ROOT}/payments/add-auto-payment/roommate-split`,
    PAYMENT_METHOD_SELECTED: `${PRIVATE_ROOT}/payments/add-auto-payment/:id/payment-method`,
  },
  EDIT_AUTO_PAYMENT: `${PRIVATE_ROOT}/payments/auto-payment/:id/edit`,
  PROPOSED_SPLIT_AUTO_PAYMENT: `${PRIVATE_ROOT}/payments/auto-payment/:id/proposed-split`,
  LEDGER: {
    ROOT: `${PRIVATE_ROOT}/payments/ledger`,
    CHARGES: `${PRIVATE_ROOT}/payments/ledger/charges`,
    PAYMENTS: `${PRIVATE_ROOT}/payments/ledger/payments`,
    INVOICE: `${PRIVATE_ROOT}/payments/ledger/invoices`,
  },
  BULK_PAYMENTS_SUCCESS: `${PRIVATE_ROOT}/payments/bulk-payment/success`,
  PAYMENT_PLAID_CONFIRM: `${PRIVATE_ROOT}/payments/plaid-account/:id/confirmation`,
  PLAID_HOSTED_LINK_RETURN: `${PRIVATE_ROOT}/plaid-hosted-link-return`,
  WALLET: `${PRIVATE_ROOT}/payments/wallet`,
  REFUNDS: `${PRIVATE_ROOT}/payments/refund-account`,
  ADD_PAYMENT_METHOD: `${PRIVATE_ROOT}/payments/add-payment-method`,
  EDIT_PAYMENT_METHOD: `${PRIVATE_ROOT}/payments/payment-method/:id/edit`,
  EDIT_ACH_PAYMENT_METHOD: `${PRIVATE_ROOT}/payments/payment-method/:id/edit-ach`,
  MAKE_PAYMENT: `${PRIVATE_ROOT}/payments/make-payment`,
  ONE_TAP_PAYMENT: `${PRIVATE_ROOT}/payments/one-tap-payment`,
  PAYMENT_SUCCESS: `${PRIVATE_ROOT}/payments/payment-success`,
  PAYMENT_SUCCESS_WO_LEDGER: `${PRIVATE_ROOT}/payments/payment-success-wo-ledger`,
  STRIPE_PAYMENT_ERROR: `${PRIVATE_ROOT}/payments/stripe-payment-error/:id/transaction`,
  STRIPE_PAYMENT_PENDING: `${PRIVATE_ROOT}/payments/stripe-payment-pending/:id/transaction`,
  ONE_TAP_PAYMENT_SUCCESS: `${PRIVATE_ROOT}/payments/:id/one-tap-payment-success`,
  ONE_TAP_PAYMENT_SUCCESS_WO_LEDGER: `${PRIVATE_ROOT}/payments/:id/one-tap-payment-success/wo-ledger`, // without ledger
  PAYMENT_SUCCESS_FOR_TRANSACTION: `${PRIVATE_ROOT}/payments/payment-success/:id/transaction`,
  REPAYMENT: {
    ROOT: `${PRIVATE_ROOT}/payments/repayments`,
    REPAYMENT_HISTORY: `${PRIVATE_ROOT}/payments/repayments/:id/history`,
    COMPLETED: `${PRIVATE_ROOT}/payments/repayments/completed`,
  },
  REVIEW_PAUSED_AUTO_PAYMENT: `${PRIVATE_ROOT}/payments/auto-payment/:id/review`,
  ADD_REFUND_METHOD: `${PRIVATE_ROOT}/payments/add-refund-method`,
  VIEW_CHARITY: `${PRIVATE_ROOT}/payments/charity/:id`,
  BULK_PAYMENTS: `${PRIVATE_ROOT}/payments/bulk-payment`,
  BULK_ONE_TIME_PAYMENT: `${PRIVATE_ROOT}/payments/bulk-payment/make-a-payment`,
  MONEYGRAM_INSTRUCTIONS: `${PRIVATE_ROOT}/payments/moneygram-instructions`,
  FLEX_PAY: `https://onboarding.getflex.com/?utm_source=MSP&utm_medium=portal&utm_campaign=Entrata__quicklink&utm_content=residentportal`,
  QUICK_LINK_PAY: `https://onboarding.getflex.com/?utm_source=MSP&utm_medium=portal&utm_campaign=Entrata__quicklink&utm_content=residentportal`,
  FLEX_LEARN_MORE: `https://getflex.com/how-it-works/`,
  STRIPE: `https://stripe.com`,
  DIRECT_DEBIT_GUARANTEE:
    'https://stripe.com/legal/bacs-direct-debit-guarantee',
  ONE_TAP_PAYMENT_INTERNATIONAL_SUCCESS: `${PRIVATE_ROOT}/payments/:id/one-tap-payment-international-success`,
  ONE_TAP_PAYMENT_INTERNATIONAL_SUCCESS_WO_LEDGER: `${PRIVATE_ROOT}/payments/:id/one-tap-payment-international-success/wo-ledger`, // without ledger
  TRANSFERMATE_PAYMENT_PENDING: `${PRIVATE_ROOT}/payments/transfermate-payment-pending/:id/transaction/`,
  TRANSFERMATE_TERMS_OF_USE: `https://transfermateeducation.com/student-terms-of-use.aspx`,
}
/**
 * Constants defining URLs related to colleen payment.
 */
export const COLLEEN_PAYMENT = {
  ROOT: `${PRIVATE_ROOT}/payment`,
  ONE_TAP_PAYMENT: `${PRIVATE_ROOT}/payment/one-tap-payment`,
  ONE_TAP_PAYMENT_SUCCESS: `${PRIVATE_ROOT}/payment/:id/one-tap-payment-success`,
  ONE_TAP_PAYMENT_SUCCESS_WO_LEDGER: `${PRIVATE_ROOT}/payment/:id/one-tap-payment-success/wo-ledger`,
  PAYMENT_PLAID_CONFIRM: `${PRIVATE_ROOT}/payment/plaid-account/:id/confirmation`,
  MONEYGRAM_INSTRUCTIONS: `${PRIVATE_ROOT}/payment/moneygram-instructions`
}


/**
 * Constants defining the URL for Plaid webhook.
 */
export const PAYMENT_GATEWAY_URL = {
  PLAID_WEBHOOK:
    'https://gateway.entrata.com/?module=payments&action=plaidhook',
}
/**
 * Constants defining Flex help link.
 */
export const FLEX_HELP_LINK = "https://help.getflex.com/hc/en-us"
